import * as yup from 'yup';

export default {
    beforeCreate()
    {
        yup.setLocale({
            mixed: {
                required: obj => `${obj.label ? obj.label : obj.path} is verplicht` // `${obj.path} is default`
            },
            string: {
                min: obj => `${obj.path} moet minstens ${obj.min} karakters lang zijn`,
                matches: obj => `Dit is geen geldig ${obj.label}.`
            }
        });
    },

    data()
    {
        return {
            formConfig: {
                telephone: {
                    label: 'Telefoonnummer',
                    name: 'telephone',
                    type: 'tel',
                    tabindex: 12
                },

                emailaddress: {
                    label: 'E-mailadres',
                    name: 'emailaddress',
                    placeholder: 'bijv. naam@lotto.nl',
                    type: 'email',
                    tabindex: 13
                },

                kit: {
                    type: 'checkbox',
                    name: 'kit',
                    id: 'kit-checkbox',
                    tabindex: 14
                }

            },

            validationSchema: yup.object().shape({
                telephone: yup.string()
                    .label( 'telefoonnummer' )
                    .nullable()
                    /* eslint-disable-next-line */
                    .matches( /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/, { excludeEmptyString: true }),
                emailaddress: yup.string()
                    .label( 'e-mail' )
                    .required()
                    .email( 'Dit is geen valide mailadres' )
                    .matches( /^((?!@lotto.nl).)*$/ )
            })
        };
    }
};
